<template>
  <v-container fluid pa-0 v-if="$hasMatchingTenantRoles(['tenant_admin'])">
    <v-row no-gutters>
      <v-col cols="12">
        <v-row align="start" justify="center" no-gutters>
          <v-col cols="12" md="5" class="pt-md-5">
            <div class="image-holder">
              <div class="grey lighten-5 rounded-circle" style="width: 100%; height: 100%">
                <v-slide-x-transition>
                  <v-row v-if="imageIsLoaded" align="start" class="fill-height" justify="center" no-gutters>
                    <img src="img/undraw_winners_re_wr1l.svg" style="height: 80%" />
                  </v-row>
                </v-slide-x-transition>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="7">
            <div class="text-left">
              <div class="title text-sm-h5 font-weight-bold mt-5 mb-5">
                {{ $t('onboarding.everything_is_done_for_now') }}
              </div>
              <div class="subtitle-2 text-sm-subtitle-1">{{ $t('onboarding.everything_is_done_info') }}</div>
              <div>
                <basic-button class="mt-10" color="primary" @click="goToTasks" outlined>
                  <v-icon left>mdi mdi-arrow-right</v-icon>
                  {{ $t('onboarding.move_to_tasks') }}
                </basic-button>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <img src="img/undraw_winners_re_wr1l.svg" style="display: none" @load="imageIsLoaded = true" />
  </v-container>
</template>

<script>
import BasicButton from '@/components/BasicButton';
export default {
  name: 'AllDone',
  components: { BasicButton },
  data() {
    return {
      imageIsLoaded: false,
    };
  },
  methods: {
    goToTasks() {
      this.$router.replace({ name: 'tenant_tasks' });
    },
  },
};
</script>

<style lang="scss" scoped>
.image-holder {
  position: relative;
  margin: auto;
  width: 245px;
  height: 245px;
}

@media screen and (min-width: 1500px) {
  .image-holder {
    width: 285px;
    height: 285px;
  }
}
</style>
